<div
  class="text-header"
  [ngClass]="{
    accent: accent,
  }"
>
  <ng-content></ng-content>
</div>
